export default {
	GET: {
		articleList: 'pc/temp/article-list', //文章资讯
		articleDetail: '/default/article-detail', //资讯详情
		// headerindex: '/pc/temp/header', // 头部
		common: '/pc/temp/head-and-tail', // 公共头尾
		// index: '/pc/temp/index', // 首页
		index: '/pc/temp/pc', // 首页
		footer: '/pc/temp/footer', //底部
		shopList: '/default/goods-list', // 商品列表
		shopgoods: '/default/goods', // 商品详情
		shopgoodsleft: '/default/goods-recommend', // 商品详情左侧推荐
		shopcat: '/cart/list', //购物车
		delectshop: '/cart/delete', // 删除购物车商品
		cartnum: '/cart/cart-num', //购物车数量
		rechargeList: '/recharge/list', //余额充值
		rechargeIndex: '/recharge/index', //余额明细
		addressList: '/user/address-list', //地址列表
		addressDelete: 'user/address-delete', //删除地址旧的
		district: '/pc/temp/district', // 地址省市区
		addressDefault: 'user/address-set-default', //设为默认地址旧的
		invoiceList: 'user/get-invoice-list', //发票抬头列表
		orderList: 'order/list', //订单列表
		orderRevoke: 'order/revoke', //取消订单
		orderPay: 'order/pay-data', //订单支付
		orderDetail: 'order/detail', //订单详情
		invoiceLists: 'pc/user/invoice-list', //发票列表
		invoiceDetails: 'pc/user/invoice', //发票详情
		confirm: 'order/confirm', //确认收货
		comment_preview: 'order/comment-preview', //确认收货
		expressDetail: 'order/express-detail', //物流
		refundPreview: 'order/refund-preview', //申请售后
		refundDetail: 'order/refund-detail', //退换货预览
		revokeRefund: 'order/revoke-refund', //撤回申请
		commentList: '/default/comment-list', //商品评价预览
		couponList: 'default/coupon-list', //优惠券
		ccouponReceive: 'coupon/receive', //优惠券领取
		shopFollow: 'mch/index/shop-follow', //商户关注
		shopUnFollow: 'mch/index/un-follow', //商户取消关注
		mchList: 'pc/temp/mch-list', //店铺街
		province: 'pc/temp/province', //店铺街-省份地区
		shopIndex: 'mch/default/index', //店铺首页
		catGoodsList: 'mch/default/cat-goods-list', //店铺商品列表
		myShop: 'mch/user/myshop', //店铺信息
		mchMessage: 'mch/default/mch-message', //入驻店铺-模板信息
		apply: 'mch/index/apply', //个人中心-入驻店铺-审核、交付平台使用费
		mchMoney: 'mch/user/mch-money', //入驻店铺-保证金
		payMoney: 'mch/user/pay-money', //入驻店铺-支付保证金
		allCategories: 'pc/temp/all-categories', //入驻店铺-全部分类
		store: 'default/store', //商城配置
		//企业采购
		qycgurl: 'business/passport/entrance',
		qycglogo: 'business/passport/entrance-logo', //企业采购公共信息            ------------------------------
		qycgfoot: 'business/passport/entrance-logo-info', //企业采购公共信息            ------------------------------
		qycgOrdered: "business/special/invoice-list", //我的发票-----发票列表  1已开票 0未开票，不传则为全部
		qycgDetails: "business/special/invoice", //我的发票----发票详情
		qycginvoiceDetails: "business/default/get-invoice", //发票详情


		// qycgentrance: 'purchase/passport/entrance',//企业采购 -> 获取入口
		qycgphone: 'pc/temp/head-and-tail', //企业采购 -> 获取服务热线
		qycgIndex: 'business/special/index', //首页   -----------------------------
		classIfication: 'purchase/default/all-categories', //全部分类
		qycgList: 'business/special/goods-list', //列表页
		productDetails: 'business/special/goods-detail', //商品详情------------------
		department: 'business/manage/activity-list', //部门列表
		deppersonal: 'purchase/framework/dep-user-list', //部门人员
		auditClassification: 'purchase/framework/examine-cat', //审核分类
		reviewGoods: 'purchase/framework/examine-goods', //审核商品
		addressData: 'default/new-district', //省市区数据
		// addressList: 'purchase/default/address-list',   //地址列表
		addressList: 'business/special/address-list', //地址列表
		addressDetails: 'default/address-detail', //地址详情
		shoppingCartList: 'business/cart/list', //购物车列表
		// shoppingCartDelete: 'qycg/cart/cart-delete', //购物车删除旧的
		shoppingNum: 'business/cart/cart-num', //购物车数量----------------------
		qycgOrderList: 'business/order/list', //订单列表
		qycgOrderDetails: 'business/order/order-detail', //订单详情
		statisticsPage: 'business/manage/order-statistic', //统计页面

		addelect: 'business/manage/activity-detail', //活动上面详情
		staffint: 'business/manage/integral-list', //员工积分
		xfrecord: 'business/manage/record-list', //消费记录
		yhgllist: 'business/manage/user-list', //用户管理
		userlister: 'business/manage/order-list', //用户订单列表
		shconter: 'business/order/refund-preview', //企业采购售后
		shlist: 'business/order/refund-list', //企业采购售后列表
		chshouhou: 'business/order/revoke-refund', //售后订单撤销退款申请
		shdetails: 'business/order/refund-detail', //售后订单详情

		qycgAuditDetails: 'purchase/framework/get-exa-setting', //审核详情
		departmentName: 'purchase/default/get-dep-name', //部门名称
		qycgInvoice: 'business/default/invoice-list', //企业采购票列表
		qycgDelInvoice: 'purchase/framework/invoice-del', //删除发票
		qycgDetailsInvoice: 'purchase/default/invoice-det', //发票详情
		statisticsOrderList: 'purchase/order/show-list', //统计订单列表
		invioceInfo: "business/manage/invoice-info", //管理端----回显发票信息

		payData: "business/order/pay-data", //订单支付
		payWay: "business/order/pay-type", //订单支付方法
		phoneVrify:"business/passport/phone-verify",//判断手机是否注册
		goodList:"business/special/goods-list-cat",
		checkOrderlist:"business/manage/check-order-list",//对账列表
		uncheckOrderlist:"business/manage/un-check-order-list",//未对账列表
		draftsList:"business/manage/drafts-list",//未对账列表
		orderDetail:"business/manage/check-order-detail",//未对账列表


	},
	POST: {
		uploadimage: 'default/upload-image', //图片上传
		whether: '/passport/user-occupation', //手机号是否存在
		resSale: '/default/res-sale', //获取短信验证token
		sendCode: '/default/send-code', //获取手机验证码
		register: '/passport/register', //注册
		pcLogin: '/passport/pc-login', //验证码登录
		changePassword: 'passport/change-password', //忘记密码
		userIndex: 'pc/user/pc', //个人中心
		// userIndex: 'pc/user/index', //个人中心
		rechargeSubmit: 'recharge/submit', //充值提交
		shopcar: '/cart/add-cart', // 加入购物车
		orderStatus: 'pc/order-status', //订单状态
		qycgorderStatus: 'business/order/check-status', //订单状态
		addressSave: '/business/special/address-edit', //地址编辑
		uploadImage: 'default/upload-image', //图片上传
		submitPreview: '/order/new-submit-preview', //预览订单
		newSubmit: '/order/new-submit', //提交订单
		modifycart: '/cart/cart-edit', //购物车修改
		pushInvoice: '/user/push-invoice', //添加发票
		userSave: 'user/user-save', //修改用户信息
		comment: 'order/comment', //修改用户信息
		refund: 'order/refund', //申请售后提交
		refundSend: 'order/refund-send', //申请售后提交
		suitAddcart: 'cart/suit-add-cart', //套餐加入购物车
		favoriteAdd: '/user/favorite-add', // 商品收藏
		favoriteRemove: '/user/favorite-remove', // 商品取消收藏
		applySubmit: 'mch/index/apply-submit', //入驻店铺-提交
		wxLogin: '/passport/wx-login', //微信登录
		wxLoginCheck: 'passport/check', //微信登录校验
		appLogin: 'passport/app-login', //微信登录绑定手机号
		//企业采购
		shoppingCartDelete: 'business/cart/cart-delete', //购物车删除
		addressDelete: 'business/special/address-del', //删除地址
		addressDefault: 'business/special/address-status', //设为默认地址
		qycglogin: 'business/passport/pc-login', //企业采购 -> 登录 -----------------------------
		qysale: 'business/default/res-sale', //企业采购 -> 验证码
		qycode: 'business/default/send-code', //企业采购 -> 短信
		addDepartment: 'purchase/framework/add-department', //添加部门
		modifyDepartment: 'purchase/framework/edit-department', //修改部门
		delDepartment: 'purchase/framework/del-department', //删除部门
		personalEditor: 'purchase/framework/add-purchase-user', //人员编辑
		personalDelete: 'purchase/framework/del-purchase-user', //人员删除
		auditSettings: 'purchase/framework/examine-setting', //审核设置
		addressEdit: 'purchase/framework/address-edit', //编辑地址
		delAddress: 'purchase/framework/del-address', //删除地址
		shoppingCartAdd: 'business/cart/add-cart', //购物车添加
		shoppingCartModify: 'business/cart/cart-edit', //购物车修改
		orderSubmissionPreview: 'business/order/submit-preview', //订单提交预览
		orderSubmission: 'business/order/submit', //订单提交
		orderReview: 'purchase/order/up-order', //订单审核
		ConfirmReceipt: 'business/order/confirm', //确认收货
		cancelOrder: 'business/order/revoke', //取消订单
		qycgAddInvoice: 'purchase/framework/invoice-edit', //添加修改发票
		shtijiao: 'business/order/refund', //售后提交
		shfahuo: 'business/order/refund-send', //售后用户发货
		addInvioce: "business/manage/invoice-edit", //管理端----保存发票信息
		queryInvoice: "business/default/push-invoice", //用户端----保存发票信息
		DelInvoice: "business/default/invoice-del", //删除发票
		defaultInvoice: "business/default/invoice-default", //默认发票
		addDrafts:"business/manage/add-drafts",//新增草稿箱
		delDrafts:"business/manage/del-drafts",//删除草稿箱
		addcheckOrder:"business/manage/add-check-order",//生成对账单
		setOrderstatus:"business/manage/set-status",//确认对账单
		setPaymentstatus:"business/manage/set-payment",//确认对账单
		
	}
}